import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  // async clearCacheForFile(filename: string): Promise<void> {
  //
  //   // Name the cache something unique to not interfere with other caches.
  //   const cache = await caches.open('audience-plus-cache');
  //
  //   try {
  //     console.error(`Trying to clear ${filename} cache.`);
  //     const keys = await cache.keys();
  //
  //     for (const key of keys) {
  //       if (key.url.includes(filename)) {
  //         await cache.delete(key);
  //       }
  //     }
  //   } catch (error) {
  //     console.error(`Error clearing ${filename} cache:`, error);
  //   }
  // }

  async clearCacheForApp(): Promise<void> {
    if (typeof globalThis !== 'undefined' && !('caches' in globalThis)) {
      // Caches not supported
      return;
    }
    try {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
    } catch (error) {
      console.error('Error clearing Audience+ cache:', error);
    }
  }
}
